'use client';

import { useSidebar } from '@/context/SidebarContext';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import { ScrollArea } from '@mantine/core';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import SidebarLinks from './sidebar-links';
import style from './sidebar.module.scss';
import { useSelector } from 'react-redux';


export const getKey = (key, title, languageSection) => {
    if (key && languageSection) {
        for (const property in languageSection) {
            if (key?.toLowerCase() === property?.toLowerCase()) {
                return languageSection[property];
            }
        }
    }
    return title;
};

const Sidebar = ({sidebarLinksData }) => {
    const { languageData } = useSelector((state) => state.language);
    const { accountType } = useSelector((state) => state.session);

    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const { lgDevice } = useBreakpoints();

    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    useEffect(() => {
        if (isSidebarOpen && !lgDevice) {
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = '';
        }

        return () => {
            document.documentElement.style.overflow = '';
        };
    }, [isSidebarOpen, lgDevice]);

    if (!isMounted) {
        return <></>;
    }

    return (
        <>
            <aside className={clsx(style.sidebar, isSidebarOpen && lgDevice && style.sidebar_close, isSidebarOpen && !lgDevice && style.sidebar_mobile_close, 'site_sidebar')}>
                <ScrollArea className={style.sidebar_scroll} type="always" offsetScrollbars={false}>
                    {!lgDevice && (
                        <div className={style.site_logo}>
                            <Link href={`/`}>
                                <Image src="/images/logo/logo-dark.svg" height={60} width={160} alt="Land base casino logo" />
                            </Link>
                        </div>
                    )}
                    <nav className={style.sidebar_wp}>
                        {sidebarLinksData.length > 0 && sidebarLinksData.map((link, index) => <SidebarLinks key={index} link={link} getKey={getKey} languageData={languageData} />)}
                    </nav>
                </ScrollArea>
            </aside>
            {!lgDevice && <div className={style.sidebar_overlay} onClick={toggleSidebar} />}
        </>
    );
};

export default Sidebar;
